/**
 * @name 콤마찍기
 * @returns boolean
 */
export const addComma = (num: any): string => {
  try {
    return Intl.NumberFormat('en-US').format(num)
  } catch (e) {
    return String(num)
  }
}
